/* istanbul ignore file */

import { DatadogServerReporter } from './adapters/datadog-server'
import { ErrorReporterManager } from './manager'

let serverReporter: ErrorReporterManager | null = null

/**
 * The server-side reporter registry.
 *
 * **To swap or add a provider, this is the only file that changes** — write an
 * adapter in `./adapters/` implementing `ErrorReporter`, then register it here.
 * Registering several fans out to all of them.
 */
export function getServerReporter(): ErrorReporterManager {
  if (!serverReporter) {
    serverReporter = new ErrorReporterManager()
    serverReporter.register(new DatadogServerReporter())
  }

  return serverReporter
}
